import React from 'react';

const PortfolioItem = ({ item, onEdit, onDelete, onView, deletingId }) => {
  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    try {
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch {
      return '';
    }
  };

  const imageCount = (item.images?.length || 0) + (item.coverImage ? 1 : 0);
  const isDeleting = deletingId === item.id;
  const safeLink = item.link ? (item.link.startsWith('http') ? item.link : `https://${item.link}`) : null;

  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-100 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 flex flex-col">
      {/* Cover Image */}
      <div className="w-full h-36 overflow-hidden rounded-t-lg relative bg-gradient-to-br from-gray-100 to-gray-200">
        {item.coverImage ? (
          <img 
            src={item.coverImage} 
            alt={item.title} 
            className="w-full h-full object-cover"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        ) : null}
        
        {/* Featured badge */}
        {item.featured && (
          <div className="absolute top-2 left-2 border border-primary text-primary bg-white/90 backdrop-blur-sm text-xs font-medium px-2 py-1 rounded">
            Featured
          </div>
        )}

        {/* Image count indicator */}
        {imageCount > 1 && (
          <div className="absolute bottom-2 right-2 bg-black/60 text-white text-xs font-medium px-2 py-0.5 rounded">
            {imageCount} photos
          </div>
        )}
      </div>

      {/* Card Body */}
      <div className="p-3.5 flex-1 flex flex-col">
        <h3 className="text-base font-semibold text-gray-900 line-clamp-1 mb-1">{item.title}</h3>
        
        {item.category && (
          <span className="inline-flex items-center self-start px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mb-2">
            {item.category}
          </span>
        )}

        <p className="text-sm text-gray-600 line-clamp-2 mb-3">{item.description}</p>

        {safeLink && (
          <a 
            href={safeLink}
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-sm text-primary hover:text-primary-dark mb-3"
          >
            View Original Content
          </a>
        )}

        {/* Footer: date + actions */}
        <div className="mt-auto pt-3 border-t border-gray-100 flex items-center justify-between">
          <span className="text-xs text-gray-500">{formatDate(item.createdAt)}</span>
          <div className="flex items-center gap-3 text-sm">
            <button 
              onClick={() => onView(item)} 
              className="text-gray-600 hover:text-primary transition-colors"
              title="View"
              aria-label="View item"
            >
              View
            </button>
            <button 
              onClick={() => onEdit(item)} 
              className="text-gray-600 hover:text-primary transition-colors"
              title="Edit"
              aria-label="Edit item"
            >
              Edit
            </button>
            <button 
              onClick={() => onDelete(item.id)} 
              disabled={isDeleting}
              className="text-gray-600 hover:text-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              title="Delete"
              aria-label="Delete item"
            >
              {isDeleting ? 'Deleting...' : 'Delete'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioItem;
